import { render, staticRenderFns } from "./RelayGiveKeyToGuest.vue?vue&type=template&id=66780d0a&"
import script from "./RelayGiveKeyToGuest.vue?vue&type=script&lang=ts&"
export * from "./RelayGiveKeyToGuest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports